import React, { Component } from 'react'

class PageNotFound extends Component {
    render() {
        return (
            <div className='not-found'>
                <h2>Nothing is here...</h2>
            </div>
        )
    }
}

export default PageNotFound
